module.exports = __webpack_public_path__ + "img/public/SiteIcons/menuIcon.svg?4f57e0c1";